import type { ComponentProps } from 'react';
import React from 'react';

import BadgeContainer from './BadgeContainer';
import BadgeDot from './BadgeDot';
import BadgeText from './BadgeText';

export const BadgePropsSize = ['sm', 'xs'] as const;
export const BadgePropsType = ['standard', 'success', 'warning', 'dangerous', 'high', 'medium', 'low'] as const;
export type BadgePropsType = (typeof BadgePropsType)[number];

export type BadgeProps = ComponentProps<'div'> & {
  type?: (typeof BadgePropsType)[number];
  dot?: boolean;
  size?: (typeof BadgePropsSize)[number];
  rounded?: boolean;
  ref?: React.Ref<HTMLElement>;
};

function Badge({ rounded, dot, ref, ...props }: BadgeProps) {
  return (
    <BadgeContainer rounded={rounded || dot} {...props} ref={ref}>
      {dot && <BadgeDot size={props.size} type={props.type} />}
      {props.children != null && <BadgeText size={props.size}>{props.children}</BadgeText>}
    </BadgeContainer>
  );
}

export default Badge;
